export const maxServiceCalls = 100;
